export default "__VITE_ASSET__CYLkUkOi__"